var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandicap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.5V7C5.5 5.89543 6.39543 5 7.5 5H7.83333C8.26607 5 8.68714 5.14036 9.03333 5.4L12.5 8V9.5L9 8V11H13.5V15.75C13.5 16.4404 12.9404 17 12.25 17C11.5596 17 11 16.4404 11 15.75V12.5H5.5Z",
    fill: "#797D80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 2,
    r: 2,
    fill: "#797D80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9489 13.74C7.9489 15.39 6.60752 16.74 4.96806 16.74C3.3286 16.74 1.98722 15.39 1.98722 13.74C1.98722 12.63 2.59333 11.68 3.47764 11.16V9C1.47055 9.64 0 11.51 0 13.74C0 16.5 2.22569 18.74 4.96806 18.74C7.71043 18.74 9.93612 16.5 9.93612 13.74H7.9489Z",
    fill: "#797D80"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandicap);
export default __webpack_public_path__ + "static/media/handicap.9d1036f20c61d02b2802583960e020d4.svg";
export { ForwardRef as ReactComponent };